import { createTRPCReact } from "@trpc/react-query"
import { type inferRouterInputs, type inferRouterOutputs } from "@trpc/server"
import superjson from "superjson"
import { type AppRouter } from "~/server/api/root"

export const api = createTRPCReact<AppRouter>()

export const transformer = {
  input: superjson,
  output: {
    // Binary path bypasses tRPC serialization entirely (handler calls procedure
    // directly via createCaller). These are only used for the streaming fallback
    // path which still goes through fetchRequestHandler.
    serialize: (x: unknown) => x as string,
    deserialize: (x: unknown) => x,
  },
}

export type RouterInputs = inferRouterInputs<AppRouter>
export type RouterOutputs = inferRouterOutputs<AppRouter>
